import * as React from "react"
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg"

function HomeLoanSvg(props) {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox="0 0 68 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle
        cx={34.0654}
        cy={33.1521}
        r={33.1521}
        fill="#F2F2FF"
        fillOpacity={0.55}
      />
      <G clipPath="url(#clip0_120_1369)">
        <Path
          d="M45.23 30.128l-4.294-1.87v-3.95a.81.81 0 01.823-.796h2.648a.808.808 0 01.823.796v5.82z"
          fill="#787681"
        />
        <Path
          d="M44.407 23.512h-1.779a.809.809 0 01.823.796v5.045l1.779.775v-5.82a.81.81 0 00-.823-.796z"
          fill="#57565C"
        />
        <Path
          d="M45.23 31.422l-.028 17.626a1.892 1.892 0 01-1.892 1.889H20.36a1.891 1.891 0 01-1.892-1.897l.028-17.62 13.351-10.321L45.23 31.422z"
          fill="#EFEFEF"
        />
        <Path
          d="M31.847 21.099l-1.074.83 12.31 9.493-.028 17.626a1.892 1.892 0 01-1.892 1.889h2.147a1.892 1.892 0 001.892-1.889l.028-17.626-13.383-10.323z"
          fill="#DADADC"
        />
        <Path
          d="M45.24 33.2L31.83 22.966 18.423 33.2a1.405 1.405 0 01-1.972-.27 1.416 1.416 0 01.268-1.979l14.686-11.206a.702.702 0 01.853 0l14.685 11.206a1.416 1.416 0 01-.661 2.524 1.404 1.404 0 01-1.043-.275z"
          fill="#2C3AD9"
        />
        <Path
          d="M28.61 23.789l-12.089 9.225a1.403 1.403 0 001.902.186l12.335-9.411a1.77 1.77 0 00-2.147 0zm18.333 7.162L32.258 19.745a.702.702 0 00-.853 0l-.647.494 14.038 10.712a1.416 1.416 0 01.198 2.063l.244.186a1.405 1.405 0 001.973-.27 1.417 1.417 0 00-.268-1.979z"
          fill="#2C3AD9"
        />
        <Path
          d="M30.476 35.491v15.446h-8.764V35.49a.286.286 0 01.286-.286h8.191a.286.286 0 01.287.286z"
          fill="#548A3E"
        />
        <Path
          d="M40.656 35.205h-7.12a.286.286 0 00-.286.286v6.678c0 .158.128.286.286.286h7.12a.286.286 0 00.286-.286V35.49a.286.286 0 00-.286-.286z"
          fill="#52BBE9"
        />
        <Path
          d="M31.831 31.776a2.147 2.147 0 100-4.294 2.147 2.147 0 000 4.294z"
          fill="#fff"
        />
        <Path
          d="M31.831 27.482c-.23 0-.46.037-.678.11a2.148 2.148 0 010 4.074 2.146 2.146 0 10.678-4.184z"
          fill="#E1E1E3"
        />
        <Path
          d="M45.235 50.937a6.613 6.613 0 114.677-1.938 6.57 6.57 0 01-4.677 1.938z"
          fill="#2C3AD9"
        />
        <Path
          d="M49.912 39.644a6.572 6.572 0 00-4.677-1.937c-.36 0-.719.03-1.074.088a6.614 6.614 0 010 13.053 6.615 6.615 0 005.751-11.204z"
          fill="#2C3AD9"
        />
        <Path
          d="M52.367 43.788a7.153 7.153 0 00-6.492-6.594l.005-3.202a1.95 1.95 0 001.507-3.473l-1.575-1.201a.535.535 0 00.072-.268v-4.747a1.347 1.347 0 00-1.36-1.332h-2.648a1.347 1.347 0 00-1.36 1.332v.977l-7.815-5.966a1.242 1.242 0 00-1.503 0L16.51 30.519a1.955 1.955 0 00.198 3.236 1.934 1.934 0 001.366.226l-.026 15.059a2.43 2.43 0 002.428 2.433h24.024a.517.517 0 00.143-.02 7.157 7.157 0 007.723-7.666zM41.59 24.303a.273.273 0 01.286-.259h2.648a.274.274 0 01.286.26v4.1l-.257-.047-2.963-2.261v-1.793zM18.216 32.77a.869.869 0 01-1.387-.816.88.88 0 01.336-.58l14.682-11.206a.166.166 0 01.201 0l11.943 9.111 2.742 2.094a.88.88 0 01.166 1.23.869.869 0 01-1.216.167L32.276 22.538a.54.54 0 00-.651 0l-13.41 10.23zm11.842 9.758h-.98a.537.537 0 000 1.074h.98v6.792h-7.692V35.736h7.692v6.791zm1.073 7.866V35.2a.537.537 0 00-.537-.537h-8.766a.537.537 0 00-.537.537v15.196h-.814a1.352 1.352 0 01-1.355-1.355l.026-15.63 12.8-9.77 12.859 9.81-.006 3.73a7.025 7.025 0 00-3.205.977v-2.958a.537.537 0 00-.536-.537h-7.692a.537.537 0 00-.537.537v7.251a.537.537 0 00.537.537h4.838a3.083 3.083 0 00-.02.12 4.488 4.488 0 00-.018.109l-.011.072a6.85 6.85 0 00-.017.126c0 .01 0 .02-.004.03l-.016.151v.025l-.015.17a6.95 6.95 0 000 1.062 7.093 7.093 0 002.075 4.528c.386.387.814.728 1.277 1.017l-10.326-.004zm6.62-12.074v-2.583h2.772v2.583H37.75zm2.302 1.074a7.114 7.114 0 00-1.556 2.52h-.747v-2.52h2.303zm-6.149-1.074v-2.583h2.773v2.583h-2.773zm2.773 1.074v2.52h-2.773v-2.52h2.773zm14.62 5.377a6.083 6.083 0 01-7.152 5.528 6.083 6.083 0 01-4.988-5.981v-.147c0-.033 0-.066.003-.099.004-.033 0-.052 0-.079 0-.026 0-.033.004-.05a.8.8 0 01.006-.101c0-.029.005-.058.007-.086l.006-.058a7.161 7.161 0 01.058-.425 5.2 5.2 0 01.058-.286 6.017 6.017 0 011.629-2.953 6.083 6.083 0 0110.376 4.293c0 .15.003.294-.008.444zm-3.09-3.936a.537.537 0 00-.538-.537h-4.824a.537.537 0 000 1.074h1.663a1.503 1.503 0 011.387.942h-3.05a.537.537 0 000 1.073h3.078a1.503 1.503 0 01-1.412 1.002h-1.635a.537.537 0 00-.433.918l3.657 3.552a.538.538 0 00.923-.389.536.536 0 00-.175-.38l-2.705-2.627h.365a2.577 2.577 0 002.523-2.076h.638a.537.537 0 100-1.073h-.65a2.576 2.576 0 00-.422-.937h1.073a.535.535 0 00.536-.54v-.002zm-13.575-11.21a2.684 2.684 0 10-5.367 0 2.684 2.684 0 005.367 0zm-2.683 1.61a1.61 1.61 0 110-3.22 1.61 1.61 0 010 3.22z"
          fill="#3C3B41"
        />
        <Path
          d="M45.224 49.696a5.385 5.385 0 113.808-1.575 5.35 5.35 0 01-3.808 1.575z"
          fill="#2C3AD9"
        />
        <Path
          d="M49.032 40.502a5.35 5.35 0 00-3.808-1.575c-.3 0-.6.026-.895.075a5.384 5.384 0 010 10.62 5.386 5.386 0 004.703-9.118v-.002z"
          fill="#2C3AD9"
        />
        <Path
          d="M45.224 50.232a5.923 5.923 0 114.187-1.735 5.884 5.884 0 01-4.188 1.735zm0-10.77a4.85 4.85 0 103.428 1.42 4.816 4.816 0 00-3.428-1.42z"
          fill="#2C3AD9"
        />
        <Path
          d="M44.633 45.34H43.28a.537.537 0 010-1.074h1.354a1.127 1.127 0 000-2.253h-.972a.537.537 0 010-1.074h.972a2.2 2.2 0 010 4.4z"
          fill="#fff"
        />
        <Path
          d="M47.21 42.013h-3.93a.537.537 0 010-1.074h3.93a.536.536 0 110 1.074zm0 1.636h-3.93a.537.537 0 010-1.073h3.93a.536.536 0 110 1.073zm-.977 4.58a.536.536 0 01-.375-.152l-2.976-2.892a.537.537 0 01.75-.77l2.976 2.892a.536.536 0 01-.374.922h-.001z"
          fill="#fff"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_120_1369">
          <Path
            fill="#fff"
            transform="translate(15.745 14.831)"
            d="M0 0H36.6418V36.6418H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default HomeLoanSvg
